import React, { useContext } from 'react'
import { Container, Title, SubTitle } from '@provi/provi-components'
import { TemplateContext } from '../../../components/template/context'
import { useISAContext } from '../../../components/template/ISA/context'
import { TemplateFormIsa } from '../../../components/template-isa'
import { FormFomik } from './form'

export const PersonalSupport = () => {
  const { creditPath, isMobile } = useContext(TemplateContext)
  const { goToNextScreen } = useISAContext()
  return (
    <TemplateFormIsa>
      <Container>
        <Title text="Qual é a sua rede de apoio pessoal? Quem são as pessoas que você recorre quando tem alguma dificuldade?" />
        <SubTitle text="Exemplo: meus pais, irmãos, namorade, amigues, etc." />
        <FormFomik data={creditPath && creditPath.ReadPersonalSupportNetwork} goToNextScreen={goToNextScreen} />
        {isMobile && <div style={{ height: '27px' }} />}
      </Container>
    </TemplateFormIsa>
  )
}
